import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { translate } from 'react-i18next';

import { updateProfile } from '../../actions/profiles';
import {
  updateProfileForm,
  setActiveTab,
  updateTimeSlot,
  removeTimeSlot,
  addTimeSlot,
  setProfile,
  reset } from '../../actions/profileForm';

import Window from '../layout/Window';
import Button from '../layout/Button';
import Loading from '../layout/Loading';
import ProfileForm from '../forms/Profile';

import './edit.scss';

class Edit extends Component {
  constructor(props) {
    super(props)
    this.handleSave = this.handleSave.bind(this);
  }

  componentDidMount() {
    if(this.props.profile) {
      this.props.setProfile(this.props.profile)
    }
  }

  componentWillReceiveProps(nextProps) {
    if(this.props.profile !== nextProps.profile) {
      this.props.setProfile(nextProps.profile)
    }
  }

  componentWillUnmount() {
    this.props.resetProfileForm();
  }

  handleSave(e) {
    const { updateProfile, profileForm, profile, match, history, location } = this.props;
    updateProfile(profileForm.profile)
      .then(r => history.push(`/organisations/${match.params.organisationId}/profiles/${profile.id}${location.search}`))
  }

  render() {
    const {
      t,
      location,
      match,
      history,
      profile,
      activeTab,
      profileForm,
      updateProfileForm,
      onBrightnessTabChange,
      onTimeSlotUpdate,
      onTimeSlotRemove,
      onTimeSlotAdd } = this.props
    if(!profile)
      return null;

    return (
      <Window
        onCloseClick={() => history.push(`/organisations/${match.params.organisationId}/profiles/${profile.id}${location.search}`)}
        title={`Profile: ${profile.name}`}
        >
        {profileForm.posting && <Loading></Loading>}
        <ProfileForm
          errors={profileForm.errors}
          profile={profileForm.profile}
          onChange={updateProfileForm}
          onTimeSlotUpdate={onTimeSlotUpdate}
          onTimeSlotRemove={onTimeSlotRemove}
          onTimeSlotAdd={onTimeSlotAdd}
          activeBrightnessTab={profileForm.activeTab}
          onBrightnessTabChange={onBrightnessTabChange} />
          <Button className="save-edit-profile" onClick={this.handleSave}>{t('UPDATE_PROFILE')}</Button>
      </Window>
    )
  }
}

export default translate('profile')(withRouter(connect(
  ({ ui, profiles }, { match }) => ({
    profile: profiles.data.find(profile => profile.id === match.params.profileId),
    profileForm: ui.profileForm
  }),
  (dispatch, { match, location, history }) => {
    return {
      setProfile: (profile) => dispatch(setProfile(profile)),
      updateProfileForm: (e) => dispatch(updateProfileForm(e)),
      resetProfileForm: () => dispatch(reset()),
      updateProfile: (profile) => dispatch(updateProfile(match.params.organisationId, profile)),
      onBrightnessTabChange: (tab) => dispatch(setActiveTab(tab)),
      onTimeSlotUpdate: (day, time, field, value) => dispatch(updateTimeSlot(day, time, field, value)),
      onTimeSlotRemove: (day, time) => dispatch(removeTimeSlot(day, time)),
      onTimeSlotAdd: (day, time, high, low) => dispatch(addTimeSlot(day, time, high, low))
    }
  }
)(Edit)));



// WEBPACK FOOTER //
// ./src/components/profiles/Edit.js